import { render } from "./teacher.vue?vue&type=template&id=0bd496bd&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"

import "./teacher.vue?vue&type=style&index=0&id=0bd496bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd496bd"]])

export default __exports__